import { localEdgeSegs, outlinePath, pieceFeatures } from "../lib/pieces";

export const PieceDrawing = ({ piece, onToggleEdge, showLabels = true, mono = false, className = "", testId = "piece-drawing" }) => {
  const L = Math.max(+piece.length || 1, 1), W = Math.max(+piece.width || 1, 1);
  const m = Math.max(L, W);
  const pad = m * 0.14;
  const sw = m / 70;
  const band = mono ? "#000" : "#E67E22";
  const line = mono ? "#000" : "#6B7280";
  const { holes, grooves, leds, drills } = pieceFeatures({ ...piece, length: L, width: W });
  const o = mono ? sw * 2.2 : 0;
  const notch = !!piece.notch?.enabled;
  const segs = {
    C1: [0, W + o, L, W + o],
    C2: [0, -o, L, -o],
    L1: [-o, 0, -o, W],
    L2: [L + o, 0, L + o, W],
  };
  const lbl = {
    C1: [L / 2, W + pad * 0.7],
    C2: [L / 2, -pad * 0.35],
    L1: [-pad * 0.5, W / 2],
    L2: [L + pad * 0.5, W / 2],
  };
  return (
    <svg
      data-testid={testId}
      viewBox={`${-pad} ${-pad} ${L + 2 * pad} ${W + 2 * pad}`}
      className={className}
      preserveAspectRatio="xMidYMid meet"
    >
      <path fillRule="evenodd" d={outlinePath({ ...piece, length: L, width: W }, (x, y) => [x, W - y])} fill={mono ? "#fff" : "#2A2F3A"} stroke={line} strokeWidth={sw / 2} />
      {grooves.map(([x, y, w, h], i) => (
        <rect key={i} x={x} y={W - y - h} width={w} height={h} fill={mono ? "none" : "#00E5FF33"} stroke={mono ? "#000" : "#00E5FF"} strokeWidth={sw / 3} strokeDasharray={`${sw} ${sw / 2}`} />
      ))}
      {leds.map(([x, y, w, h], i) => (
        <rect key={`led${i}`} x={x} y={W - y - h} width={w} height={h} fill={mono ? "#0003" : "#FACC1555"} stroke={mono ? "#000" : "#FACC15"} strokeWidth={sw / 3} />
      ))}
      {holes.map(([x, y], i) => (
        <circle key={i} cx={x} cy={W - y} r={Math.max(17.5, m / 80)} fill="none" stroke={mono ? "#000" : "#00E5FF"} strokeWidth={sw / 2.5} />
      ))}
      {drills.map(([x, y], i) => (
        <circle key={`dr${i}`} cx={x} cy={W - y} r={Math.max(4, m / 200)} fill={mono ? "#000" : "#00E5FF"} />
      ))}
      {notch && localEdgeSegs({ ...piece, length: L, width: W }).map(([x1, y1, x2, y2], i) => (
        <line key={`n${i}`} x1={x1} y1={W - y1} x2={x2} y2={W - y2} stroke={band} strokeWidth={sw * 1.6} strokeLinecap="round" />
      ))}
      {Object.entries(segs).map(([k, [x1, y1, x2, y2]]) => {
        const on = piece.edges?.[k] && !notch;
        return (
          <g key={k}>
            <line x1={x1} y1={y1} x2={x2} y2={y2} stroke={on ? band : "transparent"} strokeWidth={on ? sw * 1.6 : sw} strokeLinecap="round" />
            {onToggleEdge && (
              <line
                data-testid={`edge-toggle-${k}`}
                x1={x1} y1={y1} x2={x2} y2={y2}
                stroke="transparent" strokeWidth={sw * 6}
                style={{ cursor: "pointer" }}
                onClick={() => onToggleEdge(k)}
              />
            )}
          </g>
        );
      })}
      {showLabels &&
        Object.entries(lbl).map(([k, [x, y]]) => (
          <text key={k} x={x} y={y} fontSize={m / 16} textAnchor="middle" dominantBaseline="middle"
            fill={piece.edges?.[k] ? band : mono ? "#000" : "#9CA3AF"} fontFamily="JetBrains Mono, monospace" fontWeight="700">
            {k}
          </text>
        ))}
    </svg>
  );
};
